import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'transport-layout',
  templateUrl: './transport-layout.component.html',
  styleUrls: ['./transport-layout.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TransportLayoutComponent {
  @Input() backgroundTransform: string = '';
  @Input() backgroundImage: string = 'assets/images/covers/jumbo.jpg';

  get backgroundImageUrl(): string {
    return `url("${this.backgroundImage}")`;
  }
}
